import { render, staticRenderFns } from "./GenerateCertificate.vue?vue&type=template&id=e0c12694&scoped=true&"
import script from "./GenerateCertificate.vue?vue&type=script&lang=js&"
export * from "./GenerateCertificate.vue?vue&type=script&lang=js&"
import style0 from "./GenerateCertificate.vue?vue&type=style&index=0&id=e0c12694&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c12694",
  null
  
)

export default component.exports